/* ============================================
   ekiboost â Chatbot pour Impulse
   Prefix: eki* pour Ã©viter les conflits
   ============================================ */

var ekiChatbotResponses = {
  'quel produit choisir ?': 'Super question ! ð¯<br><br>ð¥ <strong>MOROSIL BOOST</strong> â BrÃ»leur de graisse Ã  base d\'orange sanguine Moro<br><br>ð¿ <strong>Coupe-Faim Boost</strong> â ContrÃ´le naturel de l\'appÃ©tit<br><br>â¡ <strong>LIBIBOOST HOMME</strong> â VitalitÃ© et libido masculine<br><br>ð¦ <strong>Pack Minceur</strong> â MOROSIL + Coupe-Faim Ã  prix rÃ©duit<br><br>Besoin de plus de dÃ©tails ? ð',

  'comment passer commande ?': 'C\'est trÃ¨s simple ! ð<br><br>1ï¸â£ Choisissez votre produit<br>2ï¸â£ Ajoutez-le au panier<br>3ï¸â£ Passez Ã  la caisse<br>4ï¸â£ Paiement sÃ©curisÃ© CB / PayPal<br><br>ð¡ Utilisez le code <strong>BOOST15</strong> pour -15% !',

  'quels sont les dÃ©lais de livraison ?': 'ð¦ Nos dÃ©lais :<br><br>ð«ð· <strong>France</strong> : 2-3 jours ouvrÃ©s<br>ð§ðª ð¨ð­ <strong>Belgique & Suisse</strong> : 3-5 jours<br>ð <strong>International</strong> : 5-10 jours<br><br>â <strong>GRATUIT</strong> dÃ¨s 60â¬ d\'achat !',

  'avez-vous un code promo ?': 'Oui ! ð<br><br>Utilisez <strong style="font-size:1.1em;">BOOST15</strong> pour <strong>-15%</strong> sur votre premiÃ¨re commande !<br><br>Valable sur tous les produits. Offre limitÃ©e ! ð¥'
};

var ekiDefaultResponse = 'Merci pour votre message ! ð<br><br>Je peux vous aider sur :<br>â¢ ð¯ Choisir le bon produit<br>â¢ ð° Prix et offres<br>â¢ ð¦ Livraison<br>â¢ ð·ï¸ Codes promo<br><br>Ou contactez-nous : <strong>ekiboostfr@gmail.com</strong> ð§';

var ekiChatOpen = false;

function ekiToggleChatbot() {
  ekiChatOpen = !ekiChatOpen;
  var win = document.getElementById('ekiChatbotWindow');
  var iconOpen = document.querySelector('.eki-cb-icon-open');
  var iconClose = document.querySelector('.eki-cb-icon-close');
  var notif = document.querySelector('.eki-chatbot-notif');

  if (ekiChatOpen) {
    win.classList.add('eki-open');
    iconOpen.style.display = 'none';
    iconClose.style.display = 'block';
    if (notif) notif.style.display = 'none';
    document.getElementById('ekiChatbotInput').focus();
  } else {
    win.classList.remove('eki-open');
    iconOpen.style.display = 'block';
    iconClose.style.display = 'none';
  }
}

function ekiSendQuick(msg) {
  var qa = document.getElementById('ekiQuickActions');
  if (qa) qa.style.display = 'none';
  ekiAddMsg(msg, 'eki-user');
  setTimeout(function() {
    ekiShowTyping(true);
    setTimeout(function() {
      ekiShowTyping(false);
      ekiAddMsg(ekiFindResponse(msg), 'eki-bot');
    }, 1200 + Math.random() * 800);
  }, 300);
}

function ekiSendUserMsg() {
  var input = document.getElementById('ekiChatbotInput');
  var msg = input.value.trim();
  if (!msg) return;
  input.value = '';
  ekiAddMsg(msg, 'eki-user');
  setTimeout(function() {
    ekiShowTyping(true);
    setTimeout(function() {
      ekiShowTyping(false);
      ekiAddMsg(ekiFindResponse(msg), 'eki-bot');
    }, 1000 + Math.random() * 1000);
  }, 400);
}

function ekiFindResponse(msg) {
  var lower = msg.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  for (var key in ekiChatbotResponses) {
    var nk = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (lower.indexOf(nk) !== -1 || nk.indexOf(lower) !== -1) return ekiChatbotResponses[key];
  }
  if (/morosil|brule|graisse|minci/.test(lower)) return 'Le <strong>MOROSIL BOOST</strong> est notre brÃ»leur de graisse star ! ð¥<br><br>Ã base d\'orange sanguine Moro, il contribue Ã  rÃ©duire la masse grasse abdominale.<br><br>ð° <strong>29,90â¬</strong> (au lieu de 34,90â¬)<br><br><a href="/nos-complements/morosil-boost-formule-naturelle-orange-rouge" style="font-weight:600;text-decoration:underline;">â DÃ©couvrir MOROSIL BOOST</a>';
  if (/coupe|faim|appet|fring/.test(lower)) return 'Le <strong>Coupe-Faim Boost</strong> rÃ©gule naturellement votre appÃ©tit ! ð¿<br><br>Fini les fringales et le grignotage compulsif.<br><br>ð° <strong>29,90â¬</strong> (au lieu de 34,90â¬)<br><br><a href="/nos-complements/coupe-faim-boost-controle-naturel" style="font-weight:600;text-decoration:underline;">â DÃ©couvrir Coupe-Faim Boost</a>';
  if (/libi|vital|homme|sexu/.test(lower)) return '<strong>LIBIBOOST HOMME</strong> booste votre vitalitÃ© masculine ! â¡<br><br>Stimule naturellement la libido et l\'Ã©nergie.<br><br>ð° <strong>29,90â¬</strong> (au lieu de 34,90â¬)<br><br><a href="/nos-complements/libi-boost" style="font-weight:600;text-decoration:underline;">â DÃ©couvrir LIBIBOOST</a>';
  if (/pack/.test(lower)) return 'ð¦ Le <strong>Pack Minceur</strong> combine MOROSIL + Coupe-Faim !<br><br>ð° <strong>64,90â¬</strong> au lieu de 70â¬<br>C\'est la solution complÃ¨te minceur.<br><br><a href="/nos-complements/pack-minceur" style="font-weight:600;text-decoration:underline;">â DÃ©couvrir le Pack</a>';
  if (/prix|tarif|combien|cout/.test(lower)) return 'ð° Nos tarifs :<br><br>ð¥ MOROSIL BOOST : <strong>29,90â¬</strong> <s>34,90â¬</s><br>ð¿ Coupe-Faim Boost : <strong>29,90â¬</strong> <s>34,90â¬</s><br>â¡ LIBIBOOST : <strong>29,90â¬</strong> <s>34,90â¬</s><br>ð¦ Pack Minceur : <strong>64,90â¬</strong> <s>70â¬</s><br><br>ð·ï¸ Code <strong>BOOST15</strong> = -15% en plus !';
  if (/promo|code|reduc|remise/.test(lower)) return ekiChatbotResponses['avez-vous un code promo ?'];
  if (/livr|delai|expedi/.test(lower)) return ekiChatbotResponses['quels sont les dÃ©lais de livraison ?'];
  if (/command|achet|panier/.test(lower)) return ekiChatbotResponses['comment passer commande ?'];
  if (/rembours|retour|garanti/.test(lower)) return 'â <strong>Satisfait ou RemboursÃ© 30 jours</strong><br><br>Pas satisfait ? Contactez-nous dans les 30 jours pour un remboursement intÃ©gral.<br><br>ð§ ekiboostfr@gmail.com<br>ð± 06 16 21 37 52';
  if (/bonjour|salut|hello|hey|coucou/.test(lower)) return 'Bonjour ! ð Bienvenue chez <strong>ekiboost</strong> ! Comment puis-je vous aider ?';
  if (/merci|super|parfait|genial|top/.test(lower)) return 'De rien, c\'est un plaisir ! ð N\'hÃ©sitez pas si vous avez d\'autres questions. L\'Ã©quipe <strong>ekiboost</strong> est lÃ  pour vous ! ðª';
  return ekiDefaultResponse;
}

function ekiAddMsg(content, sender) {
  var container = document.getElementById('ekiChatbotMessages');
  var div = document.createElement('div');
  div.className = 'eki-chat-msg ' + sender;
  if (sender === 'eki-bot') {
    div.innerHTML = '<div class="eki-chat-msg-avatar">ð¤</div><div class="eki-chat-msg-bubble">' + content + '</div>';
  } else {
    div.innerHTML = '<div class="eki-chat-msg-bubble">' + content + '</div>';
  }
  container.appendChild(div);
  div.style.opacity = '0';
  div.style.transform = sender === 'eki-user' ? 'translateX(20px)' : 'translateX(-20px)';
  requestAnimationFrame(function() {
    div.style.transition = 'all 0.3s ease';
    div.style.opacity = '1';
    div.style.transform = 'translateX(0)';
  });
  container.scrollTop = container.scrollHeight;
}

function ekiShowTyping(show) {
  var container = document.getElementById('ekiChatbotMessages');
  var existing = container.querySelector('.eki-typing');
  if (show && !existing) {
    var div = document.createElement('div');
    div.className = 'eki-chat-msg eki-bot eki-typing';
    div.innerHTML = '<div class="eki-chat-msg-avatar">ð¤</div><div class="eki-chat-msg-bubble eki-typing-bubble"><span class="eki-typing-dot"></span><span class="eki-typing-dot"></span><span class="eki-typing-dot"></span></div>';
    container.appendChild(div);
    container.scrollTop = container.scrollHeight;
  } else if (!show && existing) {
    existing.remove();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('ekiChatbotToggle').addEventListener('click', ekiToggleChatbot);
  setTimeout(function() {
    if (!ekiChatOpen) {
      var btn = document.getElementById('ekiChatbotToggle');
      btn.classList.add('eki-pulse');
      setTimeout(function() { btn.classList.remove('eki-pulse'); }, 3000);
    }
  }, 5000);
});
